module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/views/setting/users/users-show/users-show.component.scss
// module id = ./src/app/views/setting/users/users-show/users-show.component.scss
// module chunks = main